import { z } from 'zod';
import { Gwei } from '../lib/gwei';

const gweiTransform = (val: string | null | undefined) => (!val ? undefined : Gwei.toGwei(val));

export const MarketPriceSchema = z.object({
  productId: z.string(),
  bestBidPrice: z.string().nullable().optional().transform(gweiTransform),
  bestAskPrice: z.string().nullable().optional().transform(gweiTransform),
  oraclePrice: z.string().nullable().optional().transform(gweiTransform),
  price24hAgo: z.string().nullable().optional().transform(gweiTransform),
});

export type MarketPrice = z.infer<typeof MarketPriceSchema>;
